
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/relative-clauses-explanation';
const mainimage = '/Images/reported1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "relativeclauses" },
];

const Relativeclauses = () => (
  <GrammarPageLayout
    level="B2"
    title="Relativeclauses"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Relative Clauses Exercises"
    seoDescription="Combine sentences with who, which, that, whose, where, when. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default Relativeclauses;

